import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Row, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import { List } from './List';
import { Title } from '@/components/Typography';
import { ACTIONS, priorities } from '../constants';
import { useRosaContext } from '../../../context';
import { CustomInput, CustomSelect, FormItem, RoundedButton } from '../styles';
import { useCreateRequiredEquipment } from '../../../hooks/useCreateRequiredEquipment';

const { useFormInstance, useWatch } = Form;

export function OtherElements() {
	const form = useFormInstance();
	const { organization_id, company_id, report_id } = useRosaContext();

	const { mutateAsync: createEquipment } = useCreateRequiredEquipment();

	const fieldName = ['other_elements'];

	const options = [
		{
			label: I18n.get(ACTIONS.MAINTENANCE.label),
			value: ACTIONS.MAINTENANCE.value
		},
		{
			label: I18n.get(ACTIONS.CHANGE.label),
			value: ACTIONS.CHANGE.value
		},
		{
			label: I18n.get(ACTIONS.PROVIDE.label),
			value: ACTIONS.PROVIDE.value
		}
	];

	const name = useWatch([...fieldName, 'name']);
	const action = useWatch([...fieldName, 'action']);
	const priority = useWatch([...fieldName, 'priority']);

	const allFieldsFilled = !!name && !!action && isPrioritySelected();

	async function handleAddElement(): Promise<void> {
		const element = await form.getFieldValue([...fieldName]);

		const payload = {
			report_id,
			company_id,
			organization_id,
			equipments: [
				{
					name: element.name,
					action: element.action,
					priority: element.priority
				}
			]
		};

		createEquipment(payload, {
			onSuccess: () => {
				form.setFieldValue([...fieldName], undefined);
			},
			onError: () => {
				message.error(I18n.get('Failed to create element'));
			}
		});
	}

	function isPrioritySelected(): boolean {
		return !isNaN(priority);
	}

	return (
		<Row gutter={[0, 20]}>
			<Col span={24}>
				<Title level={5} style={{ margin: 0 }}>
					{I18n.get('Other elements')}
				</Title>
			</Col>
			<Col lg={24} xl={18}>
				<Row gutter={[20, 0]}>
					<Col lg={10} xl={12}>
						<FormItem name={[...fieldName, 'name']}>
							<CustomInput placeholder={I18n.get('New element')} />
						</FormItem>
					</Col>
					<Col lg={6} xl={5}>
						<FormItem name={[...fieldName, 'action']}>
							<CustomSelect options={options} placeholder={I18n.get('Action')} />
						</FormItem>
					</Col>
					<Col lg={6} xl={5}>
						<FormItem name={[...fieldName, 'priority']}>
							<CustomSelect options={priorities} placeholder={I18n.get('Priority')} />
						</FormItem>
					</Col>
					<Col lg={2} xl={2}>
						<RoundedButton
							type="primary"
							icon={<PlusOutlined />}
							onClick={handleAddElement}
							disabled={!allFieldsFilled}
						/>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<List />
			</Col>
		</Row>
	);
}
